import React, { useEffect, useState } from "react";
import { ReactComponent as IconNoticeClose } from "./icon/icon_notice_close.svg";
import { ReactComponent as IconNoticeDivide } from "./icon/icon_notice_divide.svg";
import { ReactComponent as IconNoticeFintech } from "./icon/icon_notice_fintech.svg";
import { ReactComponent as IconNoticeGroup } from "./icon/icon_notice_group.svg";
import { getNoticeContent, getNoticeTitle } from "../../firebase";
import { useLocation } from "react-router-dom";
import styles from "./index.module.scss";

const NewNotice = () => {
  const location = useLocation();
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [toggle, setToggle] = useState(false);
  const localFirstIn = window.localStorage.getItem("firstIn");

  // useEffect(() => {
  //   const fetchNoticeTitle = async () => {
  //     try {
  //       const res = await getNoticeTitle();
  //       if (res) {
  //         setTitle(res.asString());
  //       }
  //     } catch (error) {
  //       console.log("Error fetching notice title:", error);
  //     }
  //   };

  //   fetchNoticeTitle();
  // }, []);

  // useEffect(() => {
  //   const fetchNoticeContent = async () => {
  //     try {
  //       const res = await getNoticeContent();
  //       if (res) {
  //         setContent(res.asString());
  //       }
  //     } catch (error) {
  //       console.log("Error fetching notice title:", error);
  //     }
  //   };

  //   fetchNoticeContent();
  // }, []);

  if (location.pathname === "/") return null;
  if (location.pathname === "/loan/mortgage/apply") return null;

  return (
    <>
      <div className={styles.notice}>
        <div className={styles.layout}>
          <IconNoticeClose
            className={styles.close}
            onClick={() => {
              window.location.href = "/";
            }}
          />
          <div className={styles.noticeBanner}>公告</div>
          <div className={styles.noticeTitle}>暫停線上申貸</div>
          <div className={styles.noticeContent}>
            親愛的客戶您好：
            為因應本公司擴大運營，即需進行系統升級，暫停作業，直至系統維護完成後，再為您服務，造成您的不便，敬請見諒。
          </div>
          <button
            className={styles.homeBtn}
            onClick={() => {
              window.location.href = "/";
            }}
          >
            回首頁
          </button>
          <div className={styles.imgGroup}>
            <IconNoticeGroup />
            <IconNoticeDivide />
            <IconNoticeFintech />
          </div>
        </div>
      </div>
    </>
  );
};

export default NewNotice;
